module.exports = __webpack_public_path__ + "static/media/material_60yd_n-1.09ad9f1f.csv";